export enum Zoom {
  In,
  InIncessantly,
  Out,
  OutIncessantly,
  ZoomToFit,
}
